import { async } from 'widgets-for-react'
import { FiltersData } from './filtersLoaderState'

export const filtersLoaderWidget = async<FiltersData>
